import * as React from 'react'
import MUIFormControlLabel from '@mui/material/FormControlLabel'

const FormControlLabel = (props) => <MUIFormControlLabel {...props} />

export default FormControlLabel
